import STRINGS from "./i18n-kyc.json";

// Markoo è in italiano: usa 'it' con fallback su 'en' e infine sulla chiave.
export const useLanguage = () => ({
  lang: "it",
  t: (key) => (STRINGS.it && STRINGS.it[key]) || (STRINGS.en && STRINGS.en[key]) || key,
});
